<mat-dialog-content>
  <ng-container *ngIf="!confirmed; else confirmation">
    <p translate="inbox/task-list/mass-actions/export/question" [translateParams]="{ nb: number }"></p>
    <mat-radio-group [(ngModel)]="choice">
      <mat-radio-button [value]="choiceEnum.task">
        <span translate="inbox/task-list/mass-actions/export/task"></span>
      </mat-radio-button>
      <mat-radio-button [value]="choiceEnum.conv">
        <span translate="inbox/task-list/mass-actions/export/conv"></span>
      </mat-radio-button>
    </mat-radio-group>
  </ng-container>

  <ng-template #confirmation>
    <p
      *ngIf="choice === choiceEnum.task; else conv"
      [innerHTML]="'inbox/task-list/mass-actions/archive/task-success' | translate: { mail }"></p>
    <ng-template #conv>
      <p [innerHTML]="'inbox/task-list/mass-actions/archive/conv-success' | translate"></p>
    </ng-template>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <ng-container *ngIf="!confirmed; else ok">
    <button mat-raised-button type="button" color="primary" (click)="confirm()" [disabled]="!choice" class="confirm">
      <span translate="inbox/task-list/mass-actions/export/confirm-button" [translateParams]="{ nb: number }"></span>
    </button>
    <button mat-raised-button type="button" (click)="cancel()"><span translate="cancel"></span></button>
  </ng-container>
  <ng-template #ok>
    <button mat-raised-button type="button" color="primary" (click)="close()"><span translate="ok"></span></button>
  </ng-template>
</mat-dialog-actions>
